import { render, staticRenderFns } from "./ModalPagamentoRealtime.vue?vue&type=template&id=22617b90"
import script from "./ModalPagamentoRealtime.vue?vue&type=script&lang=js"
export * from "./ModalPagamentoRealtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports